import requestrApi from "lib/services/api/common/boxr_api_client";


const getAllJourneyDetails = (params) => (
    requestrApi({

        url: `/journeys/lsiting_journeys`,
        method: "GET",
        params,
    })
)
const getJourneyDetails = (params) => (
    requestrApi({

        url: `/journeys/web_journey_details`,
        method: "GET",
        params,
    })
)
const getWorkOrderDetails = (params) => (
    requestrApi({

        url: `/work_orders`,
        method: "GET",
        params,
    })
)
const getAllWorkOrderDetails = (params) => (
    requestrApi({

        url: `/work_orders/listing_work_orders`,
        method: "GET",
        params,
    })
)
const getMealsDetails = (params) => (
    requestrApi({

        url: `/journeys/listing_meals`,
        method: "GET",
        params,
    })
)
const getExpensesDetails = (params) => (
    requestrApi({

        url: `journeys/listing_expenses`,
        method: "GET",
        params,
    })
)


const updateJourneyDetails = (formData) => {
    return requestrApi({
        url: `/journeys/end_journey`,
        method: "PUT",
        data: formData,
    });

}
const createMeals = (formData) => {
    return requestrApi({
        url: `/journeys/create_meals`,
        method: "POST",
        data: formData,
    });

}
const createExpenses = (formData) => {
    return requestrApi({
        url: `/journeys/create_expenses`,
        method: "POST",
        data: formData,
    });

}


const linkWorkOrder = (formData) => {
    return requestrApi({
        url: `/work_orders/link_work_order`,
        method: "PUT",
        data: formData,
    });

}

const unLinkWorkOrder = (formData) => {
    return requestrApi({
        url: `/work_orders/unlink_work_order`,
        method: "PUT",
        data: formData,
    });

}


const updateMeals = (formData) => {
    return requestrApi({
        url: `/journeys/update_meals`,
        method: "PUT",
        data: formData,
    });

}
const updateExpenses = (formData) => {
    return requestrApi({
        url: `/journeys/update_expenses`,
        method: "PUT",
        data: formData,
    });

}
const deleteJourney = (params) => {
    return requestrApi({
        url: `/journeys/destroy_journey`,
        method: "DELETE",
        params
    });
};

const fetchCountries = () => {
    return requestrApi({
        url: `/countries`,
        method: "get",

    });
};
const fetchCurrency = () => {
    return requestrApi({
        url: `/currencies`,
        method: "get",

    });
};

const deleteJourneyMeals = (params) => {
    return requestrApi({
        url: `/journeys/destroy_meals`,
        method: "DELETE",
        params
    });

}
const deleteJourneyExpenses = (params) => {
    return requestrApi({
        url: `/journeys/destroy_expenses`,
        method: "DELETE",
        params
    });

}


const getAllAccountsJourneyDetails = (params) => (
    requestrApi({

        url: `/journeys/account_journeys`,
        method: "GET",
        params,
    })
)

const getAllAccountsMeals = (params) => (
    requestrApi({

        url: `/journeys/account_meals`,
        method: "GET",
        params,
    })
)
const getAllAccountsExpenses = (params) => (
    requestrApi({

        url: `/journeys/account_expenses`,
        method: "GET",
        params,
    })
)




export const FlyingSpannerServices = {
    getAllJourneyDetails,
    getJourneyDetails,
    getWorkOrderDetails,
    getMealsDetails,
    getExpensesDetails,
    updateJourneyDetails,
    linkWorkOrder,
    deleteJourney,
    getAllWorkOrderDetails,
    unLinkWorkOrder,
    fetchCountries,
    createMeals,
    createExpenses,
    updateMeals,
    updateExpenses,
    deleteJourneyMeals,
    deleteJourneyExpenses,
    fetchCurrency,
    getAllAccountsJourneyDetails,
    getAllAccountsMeals,
    getAllAccountsExpenses



}